import { render, staticRenderFns } from "./ImportDatasetPopup.vue?vue&type=template&id=15c13872"
import script from "./ImportDatasetPopup.vue?vue&type=script&lang=js"
export * from "./ImportDatasetPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports